import {RouteRecordRaw} from "vue-router";
import StaffMarketIndex from "@/modules/staff/pages/market/Index.vue";
import StaffTeamIndex from "@/modules/staff/pages/team/Index.vue";
import SackTeamIndex from "@/modules/staff/pages/team/Sack.vue";
import CareerEndedPage from "@/modules/staff/pages/CareerEndedPage.vue";

export const routes: RouteRecordRaw[] = [
  {
    name: 'staff.entry',
    path: '/staff',
    redirect: () => ({name: 'staff.index'}),
  },
  {
    path: '/staff/market',
    name: 'staff.index',
    component: StaffMarketIndex
  },
  {
    path: '/staff/team',
    name: 'staff.team.index',
    component: StaffTeamIndex
  },
  {
    path: '/staff/sack',
    name: 'staff.team.sack',
    component: SackTeamIndex
  },
  {
    path: '/staff/career-ended',
    name: 'staff.career-ended',
    component: CareerEndedPage,
  },
];